// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1NGCc","amount":"Amount_amount__2c08M","tip":"Amount_tip__3CdYj","tipHeader":"Amount_tipHeader__17Dvj","tipsWrap":"Amount_tipsWrap__3K9x_"};